import { render, staticRenderFns } from "./addChemical.vue?vue&type=template&id=c18025a0&"
import script from "./addChemical.vue?vue&type=script&lang=js&"
export * from "./addChemical.vue?vue&type=script&lang=js&"
import style0 from "./addChemical.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "addChemical.vue"
export default component.exports